export default __webpack_public_path__ + "static/media/avatar_placeholder_4.e92def9a.jpg";